import { Stack, Text, TextInput } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { IconSearch, IconX } from "@tabler/icons-react";

type Props = {
  setSearch: (e: string) => void;
};

function SearchCustomerBox({ setSearch }: Props) {
  const [value, setValue] = useState("");
  const [debounced] = useDebouncedValue(value, 1000);
  useEffect(() => {
    setSearch(debounced);
  }, [debounced, setSearch]);

  return (
    <Stack gap="" mb="xs" pos="relative">
      <TextInput
        size="md"
        description=""
        placeholder="جستجو مشتری"
        value={value}
        styles={{
          input: {
            "&::placeholder": {
              fontSize: "0.5rem",
              fontWeight: "100",
            },
          },
        }}
        onChange={(event) => setValue(event.currentTarget.value)}
        rightSection={value && <IconX onClick={() => setValue("")} />}
        leftSection={<IconSearch />}
      />

      {debounced && debounced.length > 0 && debounced?.length < 2 && (
        <Text size="xs" p="0" pos="absolute" bottom={-20} c="yellow">
          وارد کردن حداقل 2 کاراکتر برای جستجو الزامی می باشد
        </Text>
      )}
    </Stack>
  );
}

export default SearchCustomerBox;
